export default [
  {
    path: '/main/integrador/roteirization',
    meta: {
      tag: 'roteirization',
      name: 'Roteirização',
      breadcrumb: 'Roteirização',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "roteirization" */ '@/views/main/settings/integrador/roteirization/Roteirization.vue')
  }
]
